import React from 'react';
import { useSelector } from 'react-redux';
import { Alert } from 'reactstrap';
import AuctionListTemplate, {
  AuctionListTemplateContextType,
} from '../common/components/new/AuctionListTemplate';
import AuctionListItem from '../common/components/new/AuctionListItem';
import { auctionListType } from '../constants/AuctionListType';

function SearchPage() {
  const searchItems = useSelector((state) => state.search.get('items').toJS());

  return (
    <AuctionListTemplate
      context={AuctionListTemplateContextType.SEARCH}
      searchItems={searchItems}
    >
      {searchItems.length === 0 ? (
        <Alert color="info">Looks like there are no offers yet.</Alert>
      ) : (
        <>
          {searchItems.map((item) => {
            if (item?.status === 'PUBLISHED') {
              return (
                <AuctionListItem
                  key={item.id}
                  item={item}
                  context={AuctionListTemplateContextType.SEARCH}
                  listType={auctionListType.SEARCH}
                />
              );
            }
            return null;
          })}
        </>
      )}
    </AuctionListTemplate>
  );
}

export default SearchPage;
